import Typography from '@mui/material/Typography';
import CashFlowData from './PaymentsList';

const InflowPayments =({ refreshKey, onAddPayment }: { refreshKey?: number; onAddPayment?: () => void }) => {
    return(
      <>
       <Typography>
          <CashFlowData accountType={'Inflow'} type={'account-receivable'} refreshKey={refreshKey} onAddPayment={onAddPayment} />
       </Typography>
       </>
    );
};
export default InflowPayments;
